<script setup lang="ts">
import type { TpgClickEvent } from '@tpg/grammar-web';

import type { GrammarTertiaryButtonProps } from './component-types.ts';

const props = withDefaults(defineProps<GrammarTertiaryButtonProps>(), {
  size: 'regular',
  label: '',
  ariaLabel: '',
  disabled: false,
  iconTemplate: '',
  iconPosition: 'leading',
  iconOnlySize: 'large',
});

const emit = defineEmits(['click']);
function onClick(event: TpgClickEvent) {
  emit('click', event);
}
</script>

<template>
  <tpg-tertiary-button v-bind="props" @tpg-click="onClick" />
</template>
